import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Divider,
    Box,
} from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

const ModalAnuncioSistema = ({ anuncio, onEntendido }) => {
    if (!anuncio) return null;

    const fecha = new Date(anuncio.fechaPublicacion).toLocaleDateString('es-AR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    });

    return (
        <Dialog
            open
            maxWidth="sm"
            fullWidth
            onClose={(_, reason) => {
                // Sólo se cierra explícitamente con el botón para garantizar el tracking
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    onEntendido();
                }
            }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
                <SystemUpdateAltIcon color="primary" />
                Actualización del Sistema
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Typography variant="caption" color="text.secondary" display="block" mb={1.5}>
                    {fecha}
                </Typography>
                <Typography variant="h6" gutterBottom fontWeight={600}>
                    {anuncio.titulo}
                </Typography>
                <Box mt={1}>
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>
                        {anuncio.contenido}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button variant="contained" onClick={onEntendido}>
                    Entendido
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalAnuncioSistema;
